import { render } from "./kids.vue?vue&type=template&id=114c465d"
import script from "./kids.vue?vue&type=script&lang=js"
export * from "./kids.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__